import React, { useEffect } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

type Props = {
  parcelaId?: string; // opcional — filtra 1 parcela
  latlngs: L.LatLngExpression[]; // array of latitude and longitude coordinates
  markerData: any;
  centroide: any
};
// const latlngs: L.LatLngExpression[] =[
//   [
//     40.748997900584314,
//     -7.462213470417747
//   ],
//   [
//     40.748869294134344,
//     -7.462312509019406
//   ],
//   [
//     40.74884585652761,
//     -7.462330557664827
//   ],
//   [
//     40.7488516779715,
//     -7.46235762971814
//   ],
//   [
//     40.748852135730786,
//     -7.462357372911877
//   ],
//   [
//     40.74917705258078,
//     -7.463948334403786
//   ],
//   [
//     40.74942273611726,
//     -7.464093887188779
//   ],
//   [
//     40.74966254632514,
//     -7.464251694753461
//   ],
//   [
//     40.74982128323632,
//     -7.464357622653366
//   ],
//   [
//     40.75006676711442,
//     -7.464468960126468
//   ],
//   [
//     40.75024209223869,
//     -7.464534389275755
//   ],
//   [
//     40.7504338752043,
//     -7.464605961611652
//   ],
//   [
//     40.75050374559651,
//     -7.464324044609457
//   ],
//   [
//     40.75061421112794,
//     -7.46405498319825
//   ],
//   [
//     40.750664350395354,
//     -7.463927429026809
//   ],
//   [
//     40.75065981339099,
//     -7.463921317191599
//   ],
//   [
//     40.7506388504911,
//     -7.463893464191517
//   ],
//   [
//     40.74922223905332,
//     -7.462078607589558
//   ],
//   [
//     40.74922210904698,
//     -7.462078704806526
//   ],
//   [
//     40.74921243808973,
//     -7.462065444481899
//   ],
//   [
//     40.74912918003576,
//     -7.462118377126786
//   ],
//   [
//     40.74903876247824,
//     -7.462178959657354
//   ],
//   [
//     40.748997900584314,
//     -7.462213470417747
//   ]
// ]
// const markerData = [
//   { Caption: "Numero", Value: "2682422202002" },
//   { Caption: "Distrito", Value: "Portalegre" },
//   { Caption: "Concelho", Value: "Arronches" },
//   { Caption: "Freguesia", Value: "Assunção" },
//   { Caption: "Área", Value: "7.054 Ha" },
// ];
const defaultIcon = L.icon({
  iconUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

export default function IFAPMap({ latlngs, markerData, centroide }: Props) {
  useEffect(() => {
    // Inicializa o mapa na div com id 'map'
    const map = L.map('map').setView(centroide, 13); // exemplo: Lisboa
    // const map = L.map('map').setView(latlngs[0], 13); // exemplo: Lisboa

    // Adiciona o tile layer (mapa base)
    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //   attribution: '&copy; OpenStreetMap contributors',
    // }).addTo(map);

    L.tileLayer(
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      {
        attribution:
          'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics',
        maxZoom: 19,
      }
    ).addTo(map);


    // Dados do marker


    // Cria o marcador com popup mostrando os dados
    L.marker(centroide, { icon: defaultIcon })
      .addTo(map)
      .bindPopup(() => {
        const container = L.DomUtil.create('div');
        markerData.forEach((item: any) => {
          const row = L.DomUtil.create('div', '', container);
          row.innerHTML = `<strong>${item.Caption}:</strong> ${item.Value}`;
        });
        return container;
      })
      .openPopup();

    // Define os pontos da polyline


    // Cria a polyline
    const polyline = L.polyline(latlngs, { color: 'red', weight: 4 }).addTo(map);

    // Ajusta o mapa para mostrar toda a polyline
    map.fitBounds(polyline.getBounds());

    // Limpa o mapa ao desmontar o componente
    return () => {
      map.remove();
    };
  }, []);

  return <div id="map" style={{ height: '100%', width: '100%' }} />;
}
